export const MODULE_ID = "VirtoCommerce.News";
export const ENABLED_KEY = "News.Enabled";
export const USE_NEWS_PREFIX_IN_LINKS = "News.UseNewsPrefixInLinks";
export const ARTICLES_PER_PAGE = 9;
export const ARTICLES_MAX_PAGES = 10;
export const ARTICLE_TAGS_MAX = 10;
